/* ==========================================================================
   Candela Newsletter Popup — delayed open, localStorage persistence,
   fetch submit with challenge fallback
   ========================================================================== */

(function () {
  var KEY = 'candela_newsletter_popup';
  var popup = document.getElementById('CandelaNewsletterPopup');
  if (!popup) return;

  var form = document.getElementById('CandelaNewsletterPopupForm');
  var fields = popup.querySelector('[data-newsletter-fields]');
  var success = popup.querySelector('[data-newsletter-success]');
  var closeBtn = popup.querySelector('[data-newsletter-close]');
  var submitBtn = popup.querySelector('.candela-newsletter-popup__submit');
  var closeTimer = null;

  function read() {
    try {
      return localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }

  function remember(value) {
    try {
      localStorage.setItem(KEY, value);
    } catch (e) {}
  }

  function isVisible() {
    return !popup.hidden;
  }

  function open() {
    if (isVisible()) return;
    popup.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        popup.classList.add('is-visible');
      });
    });
  }

  function close() {
    if (!isVisible()) return;
    clearTimeout(closeTimer);
    popup.classList.remove('is-visible');
    setTimeout(function () {
      popup.hidden = true;
    }, 650);
  }

  function showSuccess() {
    if (fields) fields.hidden = true;
    if (success) success.hidden = false;
    remember('subscribed');
  }

  function schedule() {
    var delay = parseFloat(popup.getAttribute('data-delay'));
    if (isNaN(delay)) delay = 5;
    setTimeout(open, delay * 1000);
  }

  function start() {
    schedule();
  }

  /* --- Interactions --- */
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      remember('dismissed');
      close();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isVisible()) {
      remember('dismissed');
      close();
    }
  });

  if (form) {
    form.setAttribute('novalidate', '');

    var emailInput = form.querySelector('input[type="email"]');
    if (emailInput) {
      emailInput.addEventListener('input', function () {
        emailInput.classList.remove('is-invalid');
      });
    }

    form.addEventListener('submit', function (e) {
      if (emailInput && !emailInput.validity.valid) {
        e.preventDefault();
        emailInput.classList.add('is-invalid');
        emailInput.focus();
        return;
      }
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      if (submitBtn) submitBtn.disabled = true;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' }
      })
        .then(function (res) {
          /* Shopify may answer with a captcha page; let the browser handle it */
          if (res.url && res.url.indexOf('challenge') !== -1) {
            form.submit();
            return;
          }
          if (!res.ok) throw new Error(res.status);
          showSuccess();
          closeTimer = setTimeout(close, 6000);
        })
        .catch(function () {
          form.submit();
        })
        .then(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  /* --- Decide whether to show --- */
  if (popup.getAttribute('data-posted') === 'true') {
    showSuccess();
    open();
    closeTimer = setTimeout(close, 6000);
    return;
  }

  if (window.Shopify && window.Shopify.designMode) {
    open();
    return;
  }

  /* ?newsletter=1 resets the remembered choice and opens the popup right away (preview aid) */
  var forced = false;
  try {
    forced = new URLSearchParams(window.location.search).get('newsletter') === '1';
  } catch (e) {}
  if (forced) {
    try { localStorage.removeItem(KEY); } catch (e) {}
    open();
    return;
  }

  if (read()) return;

  start();
})();
